import axios from '../api/axiosSetup3';
import { EntityPath, ImportRecord, Plate } from '../types/plate';
import { AddPrefix, RemovePrefix } from '../tools/prefixTools';

const get = async (): Promise<Plate[]> => {
    const res = await axios.get<Plate[]>('/lpr_plate');
    return res.data; /*.map(row => ({
        ...row,
        id: `${row.customer_id}/${row.group_id}/${row.registration_number}`, // костыль
    }));*/
};

const getEntityPaths = async (): Promise<EntityPath[]> => {
    const res = await axios.get<EntityPath[]>('/v_entity_path');
    return res.data; 
};

const post = async (data: Plate): Promise<Plate> => {
    const { id, ...data1 } = data;
    // const res = await instance.post<Plate>('/lpr_plate', data1);
    const res = await axios.post<Plate[]>('/lpr_plate', data1,
        {
            headers: {Prefer: 'return=representation', },
        }
    );
    if (!res.data) return {} as Plate;
    if (!res.data.length) return {} as Plate;
    return res.status === 201 ? res.data[0] : {} as Plate;
}

const PREFIX = 'p_';

const postAndSynchronize = async (data: Plate): Promise<Plate> => {
    const { id, ...dataWithoutId } = data

  // 1. Добавляем префикс к полям, которые отправляем на сервер
    const prefixedData = AddPrefix(dataWithoutId, PREFIX)
  
    const res = await axios.post<Plate[]>('/rpc/sf_plate_insert_and_synchronize',
        prefixedData, // Отправляем данные с префиксом
        {
            headers: { Prefer: 'return=representation' },
        }
    );

    if (!res.data || !res.data.length) {
        return {} as Plate
    }

    return res.status === 200 ? res.data[0] : {} as Plate;
}

const postPlates__ = async (data: Plate[]): Promise<boolean> => {
    const platesWithoutId = data.map(plate => {
        const { id, ...plateWithoutId } = plate;
        return plateWithoutId;
    });    
    // const res = await axios.post<Plate[]>('/lpr_plate', platesWithoutId,);
    const res = await axios.post<Plate[]>('/rpc/sf_plate_bulk_insert', platesWithoutId,);
    if (!res.data) return false;
    if (!res.data.length) return false;
    return res.status === 204;
}

const postPlates = async (data: Plate[]): Promise<boolean> => {
    const platesWithoutId = data.map(({ id, ...rest }) => rest);
    
    // Передаем объект, где ключ "plates" — это наш массив данных
    const res = await axios.post('/rpc/sf_plate_bulk_insert2', { 
        plates: platesWithoutId 
    });

    // PostgREST для void функций обычно возвращает 204 No Content
    return res.status === 204;
}

const put = async (data: Plate): Promise<Plate> => {
    // const { id, ...data1 } = data;
    // const res = await instance.put<Plate>(`/lpr_plate?group_id=eq.${data.group_id}&customer_id=eq.${data.customer_id}&registration_number=eq.${data.registration_number}`, data1);
    const res = await axios.put<Plate>(`/lpr_plate?id=eq.${data.id}`, data);
    return res.status === 204 ? data : {} as Plate;
}

const putAndSynchronize = async (data: Plate): Promise<Plate> => {
    const prefixedData = AddPrefix(data, PREFIX)
    const res = await axios.post<Plate>(`/rpc/sf_plate_update_and_synchronize`, prefixedData);
    return res.status === 204 ? data : {} as Plate;
}

const delete_ = async (id: number): Promise<void> => {
    await axios.delete<Plate>(`/lpr_plate?id=eq.${id}`);
}

const importPlates = async (entity_id: number): Promise<ImportRecord[]> => {
    const res = await axios.post('/rpc/api_camera', {
        origin_id: entity_id,
        entry: 'make_action', 
        data: {action: 'info'},
        // action: get, add, remove, info
    });
    // return res.data.data.PlatesId.map((row: any, index: any) => ({registration_number: row, id: index}));
    // return res.data.data.PlateInfo.map((row: any, index: any) => ({
    //     registration_number: row.Id, 
    //     car_brand: row.CarBrand,
    //     car_owner: row.Owner,
    //     id: index,
    // }));
    return res.data.info.map((row: any, index: any) => ({
        registration_number: row.id, 
        car_brand: row.brand,
        car_owner: row.owner,
        id: index,
    }));
    
}

interface NormalizedNumber {
    plate: string;
    plate_normalized: string;
}

const normalizeNumbers = async (plate_array: string[]): Promise<NormalizedNumber[]> => {
    const res = await axios.post<NormalizedNumber[]>('/rpc/normalize_array', {plate_array});
    return res.data;
}

export const api = {
    get,
    post,
    put,
    delete: delete_,
    getEntityPaths,
    importPlates,
    postPlates,
    postAndSynchronize,
    putAndSynchronize,
    normalizeNumbers,
};